import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'iq-central-front-end-select-lesson-type',
  templateUrl: './select-lesson-type.component.html',
  styleUrls: ['./select-lesson-type.component.scss']
})
export class SelectLessonTypeComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}
  lessonId: any;
  courseCode: any;
  ngOnInit(): void {
    this.lessonId = this.route.snapshot.paramMap.get('id');
    this.courseCode = this.route.snapshot.paramMap.get('code');
    console.log(this.lessonId, this.courseCode);
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }
}
